const OPERATORS = {
  "=": (value1, value2) => value1 == value2,
  "!=": (value1, value2) => value1 != value2,
  "does exist": (value1) => !!value1,
  "does not exist": (value1) => !value1,
  "<": (value1, value2) => value1 && value2 ? Number(value1) < Number(value2) : false,
  ">": (value1, value2) => value1 && value2 ? Number(value1) > Number(value2) : false,
  ">=": (value1, value2) => value1 && value2 ? Number(value1) >= Number(value2) : false,
  "<=": (value1, value2) => value1 && value2 ? Number(value1) <= Number(value2) : false,
  "included": (value1, value2) => {
    if (value1 && value2) {
      const values = parseArray(value2);
      return values ? values.includes(value1) : false;
    }
    return false;
  },
  "is not included": (value1, value2) => {
    if (value1 && value2) {
      const values = parseArray(value2);
      return values ? !values.includes(value1) : false;
    }
    return false;
  },
  "has role": (value1, value2) => {
    if (value1 && value2) {
      const values = parseRoles(value1);
      return values ? values.includes(value2) : false;
    }
    return false;
  }
};
OPERATORS["is greater than or equal"] = OPERATORS[">="];
OPERATORS["is equal or greater than"] = OPERATORS[">="];
OPERATORS["is greater than"] = OPERATORS[">"];
OPERATORS["is lesser than or equal"] = OPERATORS["<="];
OPERATORS["is equal or lesser than"] = OPERATORS["<="];
OPERATORS["is lesser than"] = OPERATORS["<"];
OPERATORS["is not"] = OPERATORS["!="];
OPERATORS.is = OPERATORS["="];
const sanitizeInput = (rawInput) => rawInput && !rawInput.includes("{") ? rawInput.replace(/ +/g, " ").trim() : "";
const parseArray = (input) => {
  if (!input) {
    return null;
  }
  const re = /\[(.*)\]/;
  const matches = input.match(re);
  if (matches && matches[1]) {
    const values = matches[1].split(",");
    return values;
  }
  return null;
};
const parseRoles = (input) => {
  if (!input) {
    return null;
  }
  const values = input.split(",");
  return values;
};
const compareValuesOperator = (value1Raw = "", operatorRaw = "does exist", value2Raw) => {
  const value1 = sanitizeInput(value1Raw);
  const operator = sanitizeInput(operatorRaw);
  const value2 = sanitizeInput(value2Raw);
  const compareFunction = OPERATORS[operator];
  return compareFunction ? compareFunction(value1, value2) : false;
};

export { compareValuesOperator };
